import * as React from 'react';

import type { ShippingAddress } from 'types';

type Props = {
  shippingAddress: ShippingAddress
};

const ShippingAddressesPhone = (
  {
    shippingAddress
  }: Props
): JSX.Element => {
  if (!shippingAddress || !shippingAddress.phone) {
    return (
      <React.Fragment>
        –
      </React.Fragment>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {shippingAddress.phone}
    </React.Fragment>
  );
};

export default ShippingAddressesPhone;
